<template>
  <div class="container">
    <div class="custom-header">
      <div class="custom-header-content columns is-fullwidth mb-0">
        <TrfHeader class="column is-narrow is-12-mobile pb-0" pageTitle="Cadastro de tarefas" :hideDivision="true"/>
        <div class="column is-12-mobile is-flex is-justify-content-flex-end is-align-items-center pb-0">
          <TrfButtonSelector
            :listaDeOpcoes="this.opcoesTipoTarefa"
            :isAddOn="true"
            :required="true"
            class="is-fullwidth"
            id="select-tipo-tarefa"
            :podeDesmarcar="false"
            @update:opcaoSelecionada="(opcao) => (tratarTarefaSelecionada(opcao.value))"
            ref="selectTipoDeTarefa"
          />
        </div>
      </div>
      <hr />
    </div>

    <div class="columns">
      <div
        v-if="!this.permissoesTarefas || this.permissoesTarefas?.Visualizar && this.permissoesTarefas.Criar || this.isSuperAdm"
        class="column is-2-desktop is-12-mobile"
      >
        <div>
          <TrfButton
            v-if="isTarefasDoCliente"
            @click="openModal()"
            nome="Nova tarefa"
            classCor="is-primary"
            :temIcon="true"
            classIcon="mdi-plus"
            id="btn-nova-tarefa"
          />

          <TrfDropdownButton v-else
            nome="Nova tarefa"
            classIconEsquerda="mdi-plus"
            identificador="nova-tarefa-escritorio"
            :btnOptions="opcoesDoDropdownNovaTarefa"
          />
        </div>
      </div>

      <div class="column is-narrow-desktop is-12-mobile">
        <TrfButton
          v-if="isTarefasDoCliente"
          nome="Editar selecionada(s)"
          classCor="is-outlined"
          classIcon="mdi-pencil"
          class="is-fullwidth"
          id="btn-editar-selecionadas"
          title="Editar tarefa(s) selecionada(s)"
          :temIcon="true"
          :disabled="!podeEditarEmLote"
          @click="this.edicaoEmLote.openDepartamento"
        />
        <TrfDropdownButton
          v-else
          nome="Editar selecionada(s)"
          classIconEsquerda="mdi-pencil"
          identificador="editar-selecionadas"
          classCor="is-outlined"
          :disabled="!podeEditarEmLote"
          :btnOptions="opcoesDoDropdownEditarSelecionadas"
        />
      </div>

      <TrfWizardImportacaoDeTarefas
        :isAberto="isModalConfiguracaoDeTarefasActive"
        :utilizarTransicao="false"
        :opcoesSelect="opcoesCabecalhosSelect"
        :valuesSelect="VALUE_CABECALHOS_SELECT"
        @close="fecharModalConfiguracaoDeTarefas"
      />

      <ModalEdicaoTarefasEmLote
        v-if="edicaoEmLote.isModalAberto"
        :isAberto="edicaoEmLote.isModalAberto"
        :departamentos="listaTodosDepartamentos"
        :responsaveis="responsaveis"
        :tipoEdicao="edicaoEmLote.tipoEdicao"
        :isLoading="edicaoEmLote.isLoading"
        :responsavelSelecionado="edicaoEmLote.dadosEdicao?.novoResponsavelId"
        @close="edicaoEmLote.close"
        @save="edicaoEmLote.save"
      />

      <ModalPeriodoVigencia
        v-if="modalPeriodoVigencia.isAberto"
        :isAberto="modalPeriodoVigencia.isAberto"
        :isLoading="modalPeriodoVigencia.isLoading"
        @close="modalPeriodoVigencia.close"
        @save="modalPeriodoVigencia.confirmar"
      />


    </div>

    <div class="columns is-align-items-flex-end">
      <TrfInput
        class="column is-5-desktop is-fullwidth is-12-mobile"
        label="Nome"
        placeholder="Pesquise pelo nome da tarefa"
        margin="0"
        height="5.3rem"
        :temIcon="true"
        classIcon="mdi-magnify"
        id="barraPesquisa"
        v-model="this.nomeTarefa"
      />

      <div class="column is-4-desktop is-12-mobile">
        <label>Departamento</label>
        <Multiselect
          :searchable="true"
          :options="this.listaDepartamentos"
          v-model="this.departamentoId"
          class="multiselect-econtador is-fullwidth"
          placeholder="Selecione"
          noResultsText="Departamento não encontrado"
          id="select-departamento-filtrar"
        />
      </div>
      <div class="column is-2-desktop is-12-mobile ml-auto">
        <TrfButton
          id="filtro-tarefas-cadastradas"
          nome="Filtrar"
          class="is-fullwidth"
          classCor="is-primary"
          @click="this.filtrar()"
        />
      </div>
    </div>

    <div>
      <TrfModalCadastroTarefas
        :isModalActive="isModalActive"
        v-if="isModalActive"
        @trf-close-modal-cadastro="closeModal"
        :isTarefaAvulsa="isTarefaAvulsa"
        :isTarefaCliente="isTarefasDoCliente"
        ref="modalCadastroEEdicao"
        :loading="loading"
        :titulo="tituloModal"
        :edicao="edicao"
        :listaRecorrenciaECompetencia="listaRecorrenciaECompetencia"
        :tiposDePrazosEntregas="tiposDePrazosEntregas"
        :diasDaSemanaOptions="diasDaSemanaOptions"
        :listaResponsaveis="responsaveis"
        :listaDepartamentos="listaDepartamentos"
        :listaDepartamentosFase="listaTodosDepartamentos"
        :listaEmpresas="listaEmpresas"
        :listaCategorias="listaDeCategorias"
        :baixaPersonalizada="true"
        :gruposTarefaVinculados="this.gruposTarefaVinculados"
        @objetoPermissoes="getDepartamentosEEmpresasSemPermissao"
        @verificaRequisicao="isPodeAbrirModal"
      />
    </div>
    <div>
      <ModalDashboardPermissaoCadastro @close="closeModalPermissoes" v-if="isModalDashboardPermissaoActive && isAbreModal" :permissoesEmpresas="listaEmpresasSemPermissao" :permissoesDepartamentos="listaDepartamentosSemPermissao"/>
    </div>
    <div class="pt-2">
      <TrfTabela
        textoNadaEncontrado="Nenhuma tarefa foi encontrada."
        tituloExclusao="Excluir tarefa"
        :tipoTabela="'tabela-tarefas'"
        :dataConfig="this.dataSource"
        :data="this.tarefas"
        :quantidadeDeItems="this.total"
        :nextPage="this.nextPage"
        :nextLimit="this.nextLimit"
        :isButtonMoreHidden="this.hideButtonMore"
        :showDropdownOptions="!this.permissoesTarefas || this.permissoesTarefas.Visualizar && (this.permissoesTarefas.Editar || this.permissoesTarefas.Excluir) || this.isSuperAdm ? true : false"
        :showButtonsDefault="false"
        :dataStatus="this.status"
        :paginaSelecionada="this.pagina"
        :limiteAtual="this.limite"
        :textoExclusao="mensagemExclusaoDeAcordoComTipodeTarefa"
        :showGlobalLoader="this.showGlobalLoader"
        :showEdit="podeEditar"
        :showDelete="!this.permissoesTarefas || this.permissoesTarefas.Visualizar && this.permissoesTarefas.Excluir || this.isSuperAdm"
        :isMultipleSelection="true"
        @update:pagina="(pagina) => this.atualizarPagina(pagina)"
        @update:limite="(limite) => this.atualizarLimite(limite)"
        @trfTableItemSelected="setTarefasIds"
      />
    </div>
  </div>
</template>
<script>
import TrfHeader from "../../components/Header";
import TrfTabela from "../../components/Table";
import TrfInput from "../../components/Input";
import TrfButton from "../../components/Button";
import TrfModalCadastroTarefas from "../../components/Modal/TrfModalCadastroTarefas.vue";
import ModalDashboardPermissaoCadastro from "../../components/Modal/ModalDashboardPermissaoCadastro.vue";
import Tarefa from "./model/tarefa";
import Multiselect from "@vueform/multiselect";
import TrfButtonSelector from "../../components/ButtonSelector";
import { service } from "./service/cadastro-tarefas-service";
import { usuarioService } from "../../service/usuario-service";
import { toastUtils } from "../../util/toast.utils.js";
import { empresasService } from "../../service/empresas-service";
import { pessoaLogada } from "../../stateManagement/pessoaLogada.js";
import TrfWizardImportacaoDeTarefas from "../CadastroTarefas/components/WizardImportacaoDeTarefas";
import TrfDropdownButton from "../../components/DropdownButton";
import { documentoService } from "../../service/documento-service"
import { service as grupoDeTarefasService } from "../../views/GrupoDeTarefas/service/grupo-de-tarefas-service";
import { defineAsyncComponent } from "vue";

export default {
  name: "CadastroTarefas",
  components: {
    TrfHeader,
    TrfInput,
    TrfButton,
    Multiselect,
    TrfModalCadastroTarefas,
    TrfTabela,
    TrfButtonSelector,
    TrfWizardImportacaoDeTarefas,
    TrfDropdownButton,
    ModalDashboardPermissaoCadastro,
    ModalEdicaoTarefasEmLote: defineAsyncComponent(() => import('./components/ModalEdicaoTarefasEmLote')),
    ModalPeriodoVigencia: defineAsyncComponent(() => import('./components/ModalPeriodoVigencia')),
  },
  data() {
    return {
      edicao: false,
      tituloModal: "Cadastro de tarefas",
      tarefa: {},
      loading: {
        conteudo: false,
        campoEmpresas: true,
        campoResponsavel: true,
        campoDepartamento: true,
        campoRecorrencia: true,
        campoCategoria: true
      },
      isTarefaAvulsa: false,
      listaTarefasDto: [],
      isModalActive: false,
      departamentoId: "",
      dataSource: {
        columns: [
          {
            name: "nome",
            label: "Nome da tarefa",
            style: "width:27%",
          },
          {
            name: "departamento",
            label: "Departamento",
            style: "width:25%",
          },
          {
            name: "recorrencia",
            label: "Recorrência da tarefa",
            style: "width:25%",
          },
          {
            name: "status",
            label: "Status da tarefa",
            style: "width:23%",
            classe: true,
          },
        ],
        selected: null,
        itens: [],
        save: () => {},
        filter: () => this._carregarListagem(),
        select: (item) => {
          if(!this.permissoesTarefas || this.permissoesTarefas.Editar) {
            this.isModalActive = true;
            this.openModal(item);
          }
        },
        delete: (item) => this.excluir(item),
        loadMore: null,
      },
      tarefas: [],
      todasAsEmpresas: [],
      cadastrandoOuEditando: false,
      item: new Tarefa(),
      editando: false,
      status: this.statusTela,
      hideButtonMore: false,
      listagemVisivel: true,
      showTitle: false,
      pagina: 1,
      total: 0,
      limite: 10,
      listaDepartamentos: [],
      listaTodosDepartamentos:[],
      listaEmpresas: [],
      responsaveis: [],
      listaRecorrenciaECompetencia: [],
      tiposDePrazosEntregas: [],
      diasDaSemanaOptions: [],
      nomeTarefa: "",
      showGlobalLoader: false,
      permissoesTarefas: pessoaLogada.getPermissoes("Tarefas"),
      isSuperAdm: pessoaLogada.current.isSuperAdm,
      isAdm: pessoaLogada.current.Administrador,
      opcoesTipoTarefa: [
        {
          id: "btn-tipo-tarefa-escritorio",
          label: "Tarefas do escritório",
          isSelected: true,
          value: 'escritorio'
        },
        {
          id: "btn-tipo-tarefa-cliente",
          label: "Tarefas do cliente",
          isSelected: true,
          value: 'cliente'
        },
      ],
      tipoDeTarefaSelecionada: 'escritorio',
      isModalConfiguracaoDeTarefasActive: false,
      listaEmpresasSemPermissao: [],
      listaDepartamentosSemPermissao: [],
      isModalDashboardPermissaoActive: false,
      isAbreModal: false,
      gruposTarefaVinculados: [],
      listaDeCategorias: [],
      edicaoEmLote: {
        tarefasIds: [],
        isLoading: false,
        isModalAberto: false,
        tipoEdicao: 'departamento',
        dadosEdicao: null,
        close: () => {
          this.edicaoEmLote.isModalAberto = false;
        },
        openDepartamento: () => {
          this.edicaoEmLote.tipoEdicao = 'departamento';
          this.edicaoEmLote.isModalAberto = true;
        },
        openResponsavel: () => {
          this.edicaoEmLote.tipoEdicao = 'responsavel';
          this.edicaoEmLote.dadosEdicao = null;
          this.edicaoEmLote.isModalAberto = true;
        },
        save: async (event) => {
          if(this.edicaoEmLote.tipoEdicao === 'responsavel') {
            this.edicaoEmLote.dadosEdicao = {
              ...event,
            };
            this.edicaoEmLote.isModalAberto = false;
            this.modalPeriodoVigencia.isAberto = true;
            return;
          }

          this.edicaoEmLote.isLoading = true;
          const payload = {
            tarefasIds: this.edicaoEmLote.tarefasIds,
            novoDepartamentoId: event.novoDepartamentoId
          };

          const response = await service.edicaoEmLote(payload);

          if(response.status == 200) {
            toastUtils.successToast("Tarefa(s) editada(s) com sucesso!");
            this._carregarListagem();
            this.edicaoEmLote.isModalAberto = false;
          } else {
            toastUtils.dangerToast("Não possível realizar a edição. Tente novamente mais tarde!");
          }

          this.edicaoEmLote.isLoading = false;
        }
      },
      modalPeriodoVigencia: {
        isAberto: false,
        isLoading: false,
        close: () => {
          this.modalPeriodoVigencia.isAberto = false;
          this.edicaoEmLote.isModalAberto = true;
        },
        confirmar: async (dataVigencia) => {
          this.modalPeriodoVigencia.isLoading = true;
          const payload = {
            tarefasIds: this.edicaoEmLote.tarefasIds,
            novoResponsavelId: this.edicaoEmLote.dadosEdicao.novoResponsavelId == 'SEM_RESPONSAVEL'
              ? null
              : this.edicaoEmLote.dadosEdicao.novoResponsavelId,
            dataVigencia: dataVigencia
          };

          const response = await service.edicaoEmLote(payload);

          if(response.status == 200) {
            toastUtils.successToast("Tarefa(s) editada(s) com sucesso!");
            this._carregarListagem();
            this.modalPeriodoVigencia.isAberto = false;
            this.edicaoEmLote.isModalAberto = false;
          } else {
            toastUtils.dangerToast("Não possível realizar a edição. Tente novamente mais tarde!");
          }

          this.modalPeriodoVigencia.isLoading = false;
        }
      }
    };
  },
  computed: {
    hasTarefasSelecionadas() {
      return this.edicaoEmLote.tarefasIds != 0;
    },
    podeEditarEmLote() {
      return this.podeEditar && this.hasTarefasSelecionadas;
    },
    podeEditar() {
      if(!this.permissoesTarefas) return true;
      if(this.isSuperAdm) return true;
      if(this.isAdm) return true;
      if(this.permissoesTarefas?.Editar) return true;
      return false;
    },
    VALUE_CABECALHOS_SELECT() {
      const VALUE_CABECALHOS_SELECT = {
        Nome: 1,
        Descricao: 2,
        Responsavel: 3,
        Departamento: 4,
        Recorrencia: 5,
        Competencia: 6,
        APartirDe: 7,
        PrazoDeEntregaFinal: 8,
        TipoPrazoDeEntregaFinal: 9,
        PrazoDeEntregaLegal: 10,
        TipoPrazoDeEntregaLegal: 11,
        GeraMultaPorAtraso: 12,
        Vinculacao: 13,
        IgnorarColuna: 14,
      };
      return VALUE_CABECALHOS_SELECT;
    },
    opcoesCabecalhosSelect() {
      return [
        {
          label: "Nome",
          required: true,
          hidden: false,
          value: this.VALUE_CABECALHOS_SELECT.Nome,
        },
        {
          label: "Descrição",
          required: false,
          hidden: false,
          value: this.VALUE_CABECALHOS_SELECT.Departamento,
        },
        {
          label: "Responsável",
          required: false,
          hidden: false,
          value: this.VALUE_CABECALHOS_SELECT.Responsavel,
        },
        {
          label: "Departamento",
          required: true,
          hidden: false,
          value: this.VALUE_CABECALHOS_SELECT.Departamento,
        },
        {
          label: "Recorrência",
          required: true,
          hidden: false,
          value: this.VALUE_CABECALHOS_SELECT.Recorrencia,
        },
        {
          label: "Competência",
          required: true,
          hidden: false,
          value: this.VALUE_CABECALHOS_SELECT.Competencia,
        },
        {
          label: "A partir de",
          required: false,
          hidden: false,
          value: this.VALUE_CABECALHOS_SELECT.APartirDe,
        },
        {
          label: "Prazo de entrega final",
          required: true,
          hidden: false,
          value: this.VALUE_CABECALHOS_SELECT.PrazoDeEntregaFinal,
        },
        {
          label: "Tipo prazo de entrega final",
          required: true,
          hidden: false,
          value: this.VALUE_CABECALHOS_SELECT.TipoPrazoDeEntregaFinal,
        },
        {
          label: "Prazo de entrega legal",
          required: true,
          hidden: false,
          value: this.VALUE_CABECALHOS_SELECT.PrazoDeEntregaLegal,
        },
        {
          label: "Tipo prazo de entrega legal",
          required: true,
          hidden: false,
          value: this.VALUE_CABECALHOS_SELECT.TipoPrazoDeEntregaLegal,
        },
        {
          label: "Gera multa por atraso",
          required: false,
          hidden: false,
          value: this.VALUE_CABECALHOS_SELECT.GeraMultaPorAtraso,
        },
        {
          label: "Vinculação",
          required: false,
          hidden: false,
          value: this.VALUE_CABECALHOS_SELECT.Vinculacao,
          dependeDe: this.VALUE_CABECALHOS_SELECT.APartirDe,
        },
        {
          label: "Ignorar coluna",
          required: false,
          hidden: false,
          value: this.VALUE_CABECALHOS_SELECT.IgnorarColuna,
        },
      ];
    },
    opcoesDoDropdownNovaTarefa(){
      return [
        {
          nome: "Cadastrar tarefa",
          icon: "mdi-plus",
          id:"btn-nova-tarefa-escritorio",
          acao: () => this.openModal()
        },
        {
          nome: "Importar tarefas",
          icon: "mdi-upload",
          id:"btn-importar-tarefas",
          acao: () => this.openModalImportarTarefas()
        }
      ]
    },
    opcoesDoDropdownEditarSelecionadas() {
      return [
        {
          nome: "Departamento",
          icon: "mdi-folder-outline",
          id: "btn-editar-departamento-selecionadas",
          acao: () => this.podeEditarEmLote ? this.edicaoEmLote.openDepartamento() : null
        },
        {
          nome: "Responsável",
          icon: "mdi-account-group-outline",
          id: "btn-editar-responsavel-selecionadas",
          acao: () => this.podeEditarEmLote ? this.edicaoEmLote.openResponsavel() : null
        }
      ]
    },
    mensagemExclusaoDeAcordoComTipodeTarefa() {
      if(this.tipoDeTarefaSelecionada == 'escritorio') {
        return 'A tarefa será excluída de forma <strong>permanente</strong>, assim como seus vínculos e histórico na aba Minhas tarefas.<br/>Deseja realmente fazer essa exclusão?';
      } else {
        return 'A tarefa será excluída de forma <strong>permanente</strong>, assim como seus vínculos e avisos programados.<br/>Deseja realmente fazer essa exclusão?';
      }
    },
    isTarefasDoCliente() {
      if(this.tipoDeTarefaSelecionada == 'cliente') {
        return true;
      } else {
        return false;
      }
    },
    filtrosRequisicaoTarefa() {
      const objetoDeFiltro = {
        "sort[DESC]": "ativo,id",
        "recorrencia[isnot]": null,
        "nome[iLike]": `%${this.nomeTarefa}%` || "",
        pagina: this.pagina || 1,
        limit: this.limite || 10,
        "tarefaCliente[is]": this.isTarefasDoCliente
      };
      if(!!this.departamentoId) {
        this.departamentoId.includes("P")
        ? (objetoDeFiltro.departamentoPadrao = this.departamentoId.replace("P", "") || "")
        : (objetoDeFiltro.departamentoId = this.departamentoId || "");
      }

      return objetoDeFiltro;
    },
  },
  methods: {
    async adquirirDepartamentoService() {
      const { departamentoService } = await import('../../service/departamento-service.js');
      return departamentoService;
    },
    fecharModalConfiguracaoDeTarefas(event){
      this.isModalConfiguracaoDeTarefasActive = false;
      if(event) {
        window.location.reload(true);
      }
      this.opcoesCabecalhosSelect.map((opcao) => {
        opcao.hidden = false;
      })
    },
    openModalImportarTarefas() {
      this.isModalConfiguracaoDeTarefasActive = true;
    },
    tratarTarefaSelecionada(novoValor) {
      if(this.tipoDeTarefaSelecionada == novoValor) return;
      this.tipoDeTarefaSelecionada = novoValor;
      this.filtrar();
    },
    async openModal(item) {
      this.isModalActive = true;
      if (item) {
        this.loading.conteudo = true;
        this.edicao = true;
        this.tituloModal = "Editar tarefa";
        this.tarefa = await service.buscarTarefa(item.id);
        let gruposDaTarefa = await grupoDeTarefasService.buscarGrupoDeTarefasPorIdDaTarefa(item.id);
        if (gruposDaTarefa.length != 0) {
          this.montarObjetoGrupo(gruposDaTarefa);
        }
        document.addEventListener('trf-toolbar-text-editor-is-ready', () =>  {
          return;
        });
        this.loading.conteudo = false;
        await this.$refs.modalCadastroEEdicao.listarCompetencias(
          this.tarefa.recorrencia.id
        );
        this.$refs.modalCadastroEEdicao.inicializarCamposNaEdicao(this.tarefa);
      } else {
        this.edicao = false;
        this.tituloModal = "Cadastro de tarefas";
      }
    },

    montarObjetoGrupo(gruposDaTarefa) {
      gruposDaTarefa = gruposDaTarefa.map((element)=>{
        return {
          id: element.grupo.id,
          nome: element.grupo.nome
        }
      });
      this.gruposTarefaVinculados = gruposDaTarefa;
    },

    closeModal() {
      this.isModalActive = false;
    },

    async closeModalPermissoes() {
      this.isModalDashboardPermissaoActive = false;
      window.location.reload(true);
    },

    async _carregarListagem() {
      this.showGlobalLoader = true;
      try {
        let listaDeTarefas = "";
        listaDeTarefas = await service.listarTarefa(this.filtrosRequisicaoTarefa);
        this.total = parseInt(listaDeTarefas.totalDeItens);

        if (this.total === 0) {
          this.status = "is-empty";
        } else {
          this.tarefas = this._converterTarefasEmTarefasDto(listaDeTarefas);
          this.status = "";
        }
      } catch (e) {
        this.status = "is-danger";
      }
      this.showGlobalLoader = false;
    },

    async excluir(tarefa) {
      try {
        if (tarefa.padrao) {
          toastUtils.dangerToast(
            "Esta tarefa é padrão do sistema e não poderá ser excluída."
          );
          return;
        }
        await service.delete(tarefa);
        toastUtils.successToast("Tarefa excluída com sucesso!");
        const itemIndex = this.tarefas.findIndex(
          (item) => item.id === tarefa.id
        );
        this.tarefas.splice(itemIndex, 1);
      } catch (error) {
        toastUtils.dangerToast("Erro ao tentar excluir a tarefa!");
        console.error(error);
      }
    },
    async filtrar() {
      this.status = "is-loading";
      this.tarefas = [];
      this.pagina = 1;

      this._carregarListagem();
    },
    async nextPage(pagina) {
      this.pagina = pagina;

      this._carregarListagem();
    },
    async nextLimit(limite) {
      this.limite = limite;
      this._carregarListagem();
    },
    //TODO: Validar se ordenação por request esta atendendo, se estiver remover este método.
    _ordenarGridPorCodigo() {
      this.tarefas.sort(function (a, b) {
        return a.id < b.id ? -1 : a.id > b.id ? 1 : 0;
      });
    },

    _converterTarefasEmTarefasDto(listaDeTarefas) {
      this.listaTarefasDto = [];
      listaDeTarefas.data.forEach((tarefa) => {
        let nomeDepartamento = !!tarefa.departamentoPadrao && !!!tarefa.departamento
          ? tarefa.departamentoPadrao.nome
          : tarefa.departamento.nome;

        if (tarefa.recorrencia) {
          let tarefasDto = {
            id: tarefa.id,
            nome: tarefa.nome,
            departamento: nomeDepartamento,
            recorrencia: tarefa.recorrencia.descricao,
            status: tarefa.ativo ? "Ativa" : "Inativa",
            padrao: tarefa.padrao,
            baixaPersonalizada: tarefa.baixaPersonalizada
          };
          this.listaTarefasDto.push(tarefasDto);
        }
      });
      return this.listaTarefasDto;
    },

    async listarDepartamentos() {
      this.showGlobalLoader = true;
      this.loading.campoDepartamento = true;
      let departamentos = await service.listarDepartamentos();
      this.listaDepartamentos = departamentos.map((departamento) => {
        return {
          value: departamento.value.toString(),
          label: departamento.label,
        };
      });

      let departamentosPadroes = await service.listarDepartamentosPadroes();
      departamentosPadroes.forEach((departamentoPadrao) => {
        this.listaDepartamentos.push(departamentoPadrao);
      });

      this.loading.campoDepartamento = false;
      return this.listaDepartamentos;
    },

    async listarDepartamentosFase() {
      this.showGlobalLoader = true;
      this.loading.campoDepartamento = true;

      if (!this.isSuperAdm) {
        const departamentoService = await this.adquirirDepartamentoService();
        let departamentos = await departamentoService.listarTodosDepartamentos();
        this.listaTodosDepartamentos = departamentos.map((departamento) => {
          return {
            value: departamento?.value?.toString(),
            label: departamento?.label,
          };
        });
      } else {
        this.listaTodosDepartamentos = this.listaDepartamentos;
      }
      this.loading.campoDepartamento = false;
      return this.listaTodosDepartamentos;
    },

    async listarResponsaveis() {
      this.loading.campoResponsavel = true
      this.responsaveis = await usuarioService.listarResponsaveis();
      this.loading.campoResponsavel = false;
      return this.responsaveis;
    },
    async listarRecorrencias() {
      this.loading.campoRecorrencia = true;
      this.listaRecorrenciaECompetencia = await service.listarRecorrencias();
      this.loading.campoRecorrencia = false;
      return this.listaRecorrenciaECompetencia;
    },
    async listarTiposPrazosEntrega() {
      this.tiposDePrazosEntregas = await service.listarTiposPrazosEntrega();
    },
    async listarEmpresas() {
      this.loading.campoEmpresas = true;
      const filtros = {
        'filter[dataSaidaEscritorio]': empresasService.DATA_DE_SAIDA_PADRAO,
        'filter[legalizacaoEmAndamento]': false
      }
      this.listaEmpresas = await empresasService.listarEmpresas(filtros);
      this.loading.campoEmpresas = false;
    },
    async listarCategorias() {
      this.loading.campoCategoria = true;
      let categoriasPersonalizadas = await documentoService.getCategoriasPersonalizadas();
      categoriasPersonalizadas.data = categoriasPersonalizadas?.map((element)=>{
        return {
          value: element.id,
          label: element?.attributes?.descricao,
          isPersonalizada: element?.attributes?.personalizada
        }
      });
      this.listaDeCategorias = categoriasPersonalizadas.data;
      this.loading.campoCategoria = false;
    },
    atualizarPagina(pagina) {
      this.pagina = pagina;
      this._carregarListagem();
    },
    atualizarLimite(limite) {
      this.limite = limite;
    },
    getDepartamentosEEmpresasSemPermissao(value) {
      this.listaDepartamentosSemPermissao = value.departamentosSemPermissao;
      this.listaEmpresasSemPermissao = value.empresasSemPermissao;

      if (this.listaDepartamentosSemPermissao.length > 0 || this.listaEmpresasSemPermissao.length > 0) {
        this.isModalDashboardPermissaoActive=true;
      }
    },
    isPodeAbrirModal(value) {
      this.isAbreModal = value;
      this.isModalActive = false;
    },
    setTarefasIds(tarefas) {
      const tarefasIds = tarefas.map(t => t.id);
      this.edicaoEmLote.tarefasIds = tarefasIds;
    }
  },
  async mounted() {
    this.listarResponsaveis();
    this.listarRecorrencias();
    this.listarTiposPrazosEntrega();
    this.listarEmpresas();
    await this.listarDepartamentos();
    await this.listarDepartamentosFase();
    this._carregarListagem();
    this.listarCategorias();
  },
};
</script>
<style lang="scss" scoped>
.multiselect-econtador {
  margin: 0;
}
</style>
